import { render, staticRenderFns } from "./SlashForwardBox.vue?vue&type=template&id=020cd32f"
import script from "./SlashForwardBox.vue?vue&type=script&lang=js"
export * from "./SlashForwardBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports